import { useApi } from '@omnipresentgroup/api';
import { getUserMainRole } from '@omnipresentgroup/helpers';
import type {
  DocumentCreation,
  DocumentCreationRequest,
  DocumentCreationResponseAPI,
} from '@omnipresentgroup/types';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { useUser } from '../../users';
import { API_BASE } from '../constants';
import { transformDocumentCreateRequestToAPI } from '../mappers';

const API_PATH = 'documents';

export const useDocumentCreate = () => {
  const { POST } = useApi();
  const { data: opUser } = useUser();
  const queryClient = useQueryClient();

  const createDocument = useCallback(
    async (payload: DocumentCreationRequest): Promise<DocumentCreation> => {
      try {
        const response = await POST<DocumentCreationResponseAPI>({
          path: `${API_BASE}/${API_PATH}`,
          body: {
            userId: opUser?.userId,
            tenantId: opUser ? getUserMainRole(opUser.roles).tenantId : null,
            ...transformDocumentCreateRequestToAPI(payload),
          },
        });
        queryClient.invalidateQueries({
          queryKey: [API_PATH],
          refetchType: 'all',
        });
        return new Promise<DocumentCreation>((resolve) => resolve(response));
      } catch (error) {
        return new Promise((_, reject) => reject(error));
      }
    },
    [POST, opUser, queryClient],
  );

  return {
    createDocument,
  };
};
